import http from './http'
import axios from 'axios';
// 福建统一登录
//获取用户信息
export const getUserInfo = (data) => {
  // return http.post('/invokeservice.do', {
  //   POSTPARAM_JSON: JSON.stringify(data)
  // }) 
  // let params={
  //   POSTPARAM_JSON:data
  // }
  // return http.post(
  //   '/invokeservice.do',
  //   JSON.stringify(params),
  //   {
  //     'Content-Type': 'application/x-www-form-urlencoded'
  //     // 'Content-Type': 'multipart/form-data'
  // }
  // )
  // return http.post('/invokeservice.do',params)
  var instance = axios.create({
      baseURL: '',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
      params: {
        POSTPARAM_JSON: data
      }
  });
  return instance.post('/invokeservice.do', {
    POSTPARAM_JSON: data
  })
  // return instance.post('/invokeservice.do', JSON.stringify(data))
}